import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const fetchWithCredentials = (uri, options = {}) =>
	fetch(uri, { ...options, credentials: 'include' });

const client = new ApolloClient({
	link: new HttpLink({
		uri: import.meta.env.VITE_API_GRAPHQL_URL,
		credentials: 'include',
		fetch: fetchWithCredentials,
	}),
	cache: new InMemoryCache(),
});

export default client;
